import { createReducer, on } from '@ngrx/store';
import { TwePopup } from '../../create-request/models/internal-transfer/TwePopup';
import { StandingAuthAchActions, StandingAuthCheckActions, StandingAuthFormActions, StandingAuthInternalTransferActions, StandingAuthWireActions } from '../actions';

export const twePopupKey = 'twePopupInfo';

export interface State extends TwePopup { }

export const initialTwePopupState: State = {
    openTwePopup: false,
    totalRows: 0,
    isFirstTimeDistribution: false,
    isTweOnFile: false,
    isNonNAState: false,
    existingAccountFederalTaxWithholdingElection: false,
    existingAccountStateTaxWithholdingElection: false,
    existingAccountFedTaxRate: 0,
    existingAccountStateTaxRate: 0,
    fedTaxRateUserEntered: 0,
    stateTaxRateUserEntered: 0,
    accountDetails: {
        aprOverflowIn: false,
        sloaOverflowInd: false,
        recurringOverflowInd: false,
        returnCode: '',
        errorCode: 0,
        errorMessage: '',
        errorDetails: '',
        totalRowsApr: 0,
        totalRowsSloa: 0,
        totalRowsRecurring: 0,
        hasRecurringTxn: false,
        hasSloaTxn: false,
        accountLevelInfo: {
            trustAccountIndicator: false,
            hasWfpaRoleIndicator: false,
            hasNdfaRoleIndicator: false,
            hasLpfaRoleIndicator: false,
            masterSubAssociationIndicator: false,
            accountRegistrationValidIndicator: false,
            checkRestrictionIndicator: false,
            journalRestrictionIndicator: false,
            moneylinkRestrictionInIndicator: false,
            moneylinkRestrictionOutIndicator: false,
            validBirthDateIndicator: false,
            validTaxpayerIdIndicator: false,
            validRcFrmBptIndicator: false,
            cashMoneyMarketFundAmount: 0,
            availableToBorrowAmount: 0,
            rmdEligibleIndicator: false,
            rmdActiveRecurringIndicator: false,
            customer592Date: '',
            customer702Date: '',
            rmdAnnualCalcAmount: 0,
            rmdAnnualPaidYearToDateAmount: 0,
            rmdAnnualRemainAmount: 0,
        },
        cashieringRequestAprs: [],
        recurringRequests: [],
        sloaRequests: [],
    },
    regShortName: '',
};

export const reducer = createReducer(
    initialTwePopupState,
    on(
        StandingAuthInternalTransferActions.callInternalTransferVerify,
        StandingAuthWireActions.callWiresVerifyV3,
        StandingAuthCheckActions.callVerify,
        StandingAuthAchActions.callAchVerify,
        (_, action) => {
            return initialTwePopupState;
        }
    ),
    on(StandingAuthWireActions.verifyV3CallSuccessful, (state, {response}) => {
        return {
            ...state,
            ...response.twePopup,
        };
    }),
    on(StandingAuthInternalTransferActions.verifyCallSuccessful, (state, action) => {
        const { response } = action;
        return {
          ...state,
          ...response.twePopup,
        };
    }),
    on(StandingAuthCheckActions.verifyCallSuccessful, (state, action) => {
        const { checkVerifyResponse } = action;
        return {
          ...state,
          ...checkVerifyResponse.twePopup,
        };
    }),
    on(StandingAuthAchActions.verifyCallSuccessful, (state, {response}) => {
        return {
          ...state,
          ...response.twePopup,
        };
    }),
    // TODO: Handle review page cancel click 
    on(
        // ReviewPageActions.cancelClicked,
        StandingAuthFormActions.cancelClicked,
        (_) => {
            return initialTwePopupState;
        }
    )
);
